import { IsString, Length, IsEmail, MaxLength, IsNotEmpty } from "class-validator";
import { IsBrPhone } from "./validation/customValidators";
import request from "./request";

export class ContactMessage {
	@IsNotEmpty()
  @IsString()
  @MaxLength(255)
  name: string = "";

  @IsString()
  @Length(0, 255)
  company: string = "";

	@IsNotEmpty()
  @IsEmail()
	email: string = "";

	@IsNotEmpty()
  @IsBrPhone()
  phone: string = "";

	@IsNotEmpty()
  @IsString()
  @MaxLength(2000)
	text: string = "";

	async send() {
		return request.send("contact", "sendMessage", this);
	}
}
